import _isEmpty from 'lodash/isEmpty';
import React, { Component } from 'react';
import { ResponsiveContainer, Treemap, Tooltip } from 'recharts';
import history from '$lib/history';
import styles from './styles.scss';

const COLORS = ['#8889DD', '#9597E4', '#8DC77B', '#A5D297', '#E2CF45', '#F8C12D'];

class CustomizedContent extends Component {
  render() {
    const { children, depth, x, y, width, height, completedAt, name, path } =
      this.props;

    const fill = _isEmpty(children) // eslint-disable-line no-nested-ternary
      ? completedAt
        ? '#40b86c'
        : '#d1d1d1'
      : 'rgba(255,255,255,0)';

    return (
      <g onClick={() => history.push(path)} style={{ cursor: 'pointer' }}>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            fill,
            stroke: '#fff',
            strokeWidth: 2 / (depth + 1e-10),
            strokeOpacity: 1 / (depth + 1e-10),
          }}
        />
        {depth === 1 ? (
          <text
            x={x + width / 2}
            y={y + height / 2 + 7}
            textAnchor="middle"
            fill="#fff"
            fontSize={14}
            className={styles.cellText}
          >
            {name}
          </text>
        ) : null}
      </g>
    );
  }
}

const CustomTooltipContent = (props) => {
  if (props.payload[0] != null) {
    const { name } = props.payload[0].payload;
    const time = `${Math.max(
      1,
      Math.ceil(props.payload[0].payload.value / 1000 / 60)
    )} min read`;

    return (
      <div className={styles.tooltip}>
        <div className={styles.chapter}>{name}</div>
        <div className={styles.time}>{time}</div>
      </div>
    );
  }

  return null;
};

const recursivelyAugmentContent = (content) => {
  const data = content.map((contentInstance) => ({
    name: contentInstance.name,
    completedAt: contentInstance.completedAt,
    size: contentInstance.readingTimeMs,
    path: contentInstance.path,
    children: recursivelyAugmentContent(contentInstance.content),
  }));
  return data;
};

class ContentProgressTreemap extends Component {
  render() {
    const { inflatedContent } = this.props;

    const data = recursivelyAugmentContent(inflatedContent);

    return (
      <ResponsiveContainer width="99%" height={240}>
        <Treemap
          data={data}
          dataKey="size"
          ratio={4 / 3}
          stroke="#fff"
          fill="#8884d8"
          content={<CustomizedContent colors={COLORS} />}
          isAnimationActive={false}
          className="aaaContentTreemap"
        >
          <Tooltip content={<CustomTooltipContent />} />
        </Treemap>
      </ResponsiveContainer>
    );
  }
}

export default ContentProgressTreemap;
